import type React from 'react';

import { isBusyNow, isConfirmed, useSchedule, useTz } from '@entities/schedules';
import cn from 'classnames';
import format from 'date-fns/format';

import { getSessionBlock } from '@shared/helpers';

import * as st from './styles.module.scss';

interface Props {
	start: Date;
	end: Date;
	scheduleId: number;
	blockType?: string;
}

export const BusyStartTime: React.FC<Props> = ({ start, end, scheduleId }) => {
	const { schedule } = useSchedule(scheduleId);
	const { tz } = useTz();

	const blockType = getSessionBlock({ start, end }, tz, schedule?.start_time, schedule?.end_time);

	const isNow = isBusyNow(schedule);

	const confirmed = isConfirmed(schedule);

	return (
		<div
			className={cn(st.time, st[blockType], isNow && st.now)}
			onMouseOver={(e) => e.stopPropagation()}
		>
			<div className={cn(st.confirm, !confirmed && st.confirm__unconfirmed)}>
				{(blockType === 'start' || blockType === 'start_topOverlap' || blockType === 'single') &&
					format(start, 'HH:mm')}
			</div>
		</div>
	);
};
